import React from "react";
import { formatNumber } from "utils/currencyFormat";

export const ContentTable = ({ listDataDanhSach }) => {
  if (listDataDanhSach == undefined || listDataDanhSach.length === 0)
    return null;

  return listDataDanhSach?.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">{index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm  action-cell">
        <span className="mobile-column-name">Mã phiếu</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.ThuChiCode}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Ngày</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.Time}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Nhân viên</span>
        <div className="center-wrapper color7">
          <p className="text-left">{item.UserName}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
        <span className="mobile-column-name">Ghi chú</span>
        <div className="center-wrapper color7">
          <p className="text-left">{item.Note}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Chi trích lập</span>
        <div className="center-wrapper color7">
          <p className="text-right color-do">{formatNumber(item.ValueChi)}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Thu trích lập</span>
        <div className="center-wrapper color7">
          <p className="text-right color-xanh">{formatNumber(item.ValueThu)}</p>
        </div>
      </div>
    </div>
  ));
};
